module.exports = __webpack_public_path__ + "img/bellexr_background.a094dac0.svg";